(function (window, undefined) {
  'use strict';
  var Run = function (
    $rootScope,
    $http,
    $q,
    userSrvc,
    messaggiFctr,
    labelSrvc,
    loggerSrvc,
    CONSTANTS,
    ssocoreServices
  ) {
    var userSrvcDefer = $q.defer();
    var labelSrvcDefer = $q.defer();
    userSrvc.abilitazioniPronte = userSrvcDefer.promise;
    labelSrvc.labelsPronte = labelSrvcDefer.promise;

    // Mi metto in ascolto dell'evento run-telepass che viene emesso quando
    // il token è stato arricchito con le informazioni necessarie per i
    // filtri delle API. Una volta che il token è stato aggiornato lancio le
    // chiamate per l'avvio dell'applicazione.
    $rootScope.$on('brio3-run-telepass', function (event, error) {
      startApplication();
    });

    var startApplication = function () {
      ssocoreServices.caricaContesto(
        function (response) {
          if (
            ssocoreServices.caricaFunzionalita(response, 'presaInCaricoBanca')
          ) {
            userSrvc.presaInCaricoBanca = true;
          }
          if (
            ssocoreServices.caricaFunzionalita(response, 'presaInCaricoFiliale')
          ) {
            userSrvc.presaInCaricoFiliale = true;
          }
          if (
            ssocoreServices.caricaFunzionalita(response, 'configurazioneSoglie')
          ) {
            userSrvc.configurazioneSoglie = true;
          }
          if (
            ssocoreServices.caricaFunzionalita(
              response,
              'visualizzazioneApparati'
            )
          ) {
            userSrvc.visualizzazioneApparati = true;
          }

          startAbilitazioniPromise();
          startLabelsPromise();
          startLoggerPromise();
        },
        function (reason) {}
      );
    };

    var startAbilitazioniPromise = function () {
      $http({
        method: 'GET',
        url: CONSTANTS.REST_ROOT + CONSTANTS.REST.GENERAL.USER,
      }).then(
        function (response) {
          if (messaggiFctr.processaResponse(response)) {
            userSrvcDefer.reject(response);
            return;
          }
          userSrvc.user = response.data.result.profile;
          userSrvc.abilitazioni = response.data.abilitazioni;
          userSrvcDefer.resolve(true);
        },
        function (reason) {
          messaggiFctr.processaResponse(reason);
          userSrvcDefer.reject(reason);
        }
      );
    };

    var startLabelsPromise = function () {
      $http({
        method: 'GET',
        url: CONSTANTS.REST_ROOT + CONSTANTS.REST.GENERAL.LABEL,
      }).then(
        function (response) {
          if (messaggiFctr.processaResponse(response)) {
            labelSrvcDefer.reject(response);
            return;
          }
          labelSrvc.labels = response.data.result;
          labelSrvcDefer.resolve(true);
        },
        function (reason) {
          messaggiFctr.processaResponse(reason);
          labelSrvcDefer.reject(reason);
        }
      );
    };

    var startLoggerPromise = function () {
      $http({
        method: 'GET',
        url: CONSTANTS.REST_ROOT + CONSTANTS.REST.GENERAL.LOG,
      }).then(
        function (response) {
          if (messaggiFctr.processaResponse(response)) {
            return;
          }
          loggerSrvc.setupLogger(response.data.result);
          // FIXME: riabilitare per gestire correttamente i permessi
          labelSrvc.develop = loggerSrvc.levelEnabled(loggerSrvc.FINE);
        },
        function (reason) {
          messaggiFctr.processaResponse(reason);
        }
      );
    };
  };

  Run.$inject = [
    '$rootScope',
    '$http',
    '$q',
    'TlpsUserSrvc',
    'TlpsMessaggiFctr',
    'TlpsLabelSrvc',
    'TlpsLoggerSrvc',
    'TLPS_CONSTANTS',
    'ssocoreServices',
  ];
  angular.module('cbl.telepass.wa').run(Run);
})(window);



//////////////////
// WEBPACK FOOTER
// ./app/app.run.js
// module id = 3
// module chunks = 0